var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-calendar',{attrs:{"date-format-options":{ year: 'numeric', month: 'numeric', day: 'numeric' },"button-only":"","initial-date":"","hide-header":"","label-help":"","no-close-on-select":"","date-info-fn":_vm.dateClass},on:{"selected":function($event){return _vm.onDateSelected($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }